import React from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import AdminLeads2 from '../Admin/AdminLeads2';
import AgentLayout from './AgentLayout';
import { useAgentAuth } from '../../contexts/AgentAuthContext';
import { Leads2PortalProvider } from '../../contexts/Leads2PortalContext';

const AgentLeads2Page = () => {
  const navigate = useNavigate();
  const { agentToken, agentUser } = useAgentAuth();
  if (!agentToken || !agentUser) return <Navigate to="/agent/login" replace />;
  const value = {
    token: agentToken,
    role: 'agent',
    basePath: '/agent/leads2',
    currentUserId: agentUser?.id || null,
    currentUserName: `${agentUser.firstName || ''} ${agentUser.lastName || ''}`.trim(),
    Layout: AgentLayout,
  };
  return (
    <Leads2PortalProvider value={value}>
      <AdminLeads2 onNavigateDetail={(leadId) => navigate(`/agent/leads2/${leadId}`)} />
    </Leads2PortalProvider>
  );
};

export default AgentLeads2Page;
